let original = document.title;
let count = 0;

export function bumpTitleAlert() {
  count += 1;
  document.title = `🔔 New message (${count})`;
}

export function clearTitleAlert() {
  count = 0;
  document.title = original;
}
